import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    LIST_MESSAGES_OF_USER_REQUEST,
    LIST_MESSAGES_OF_USER_SUCCESS,
    LIST_MESSAGES_OF_USER_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const ListMessagesOfUserAction = (userPageIdFromFacebook, limit = 500, page = 1) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_FB_BOT}/api/messages?limit=${limit}&user_page_id_from_facebook=${userPageIdFromFacebook}&sort=-created_at&page=${page}`,
        method: 'GET',
        headers: (headers()),
        types: [
            LIST_MESSAGES_OF_USER_REQUEST,
            {
                type: LIST_MESSAGES_OF_USER_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": LIST_MESSAGES_OF_USER_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: LIST_MESSAGES_OF_USER_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": LIST_MESSAGES_OF_USER_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {ListMessagesOfUserAction}